import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage
    id="livestream-events.sidebar.concerts-and-courses.title"
    defaultMessage="Concerts & Courses"
  />
);
